import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getBackFillList,
  postBackfill,
} from '@/features/backfill/api/backfill.api.tsx';
import type {
  BackfillExecutionParams,
  PostBackfillRequest,
} from '@/features/backfill/types/backfill.types.ts';

export const getBackfillExecutions = createAsyncThunk(
  'backfill/getBackfillExecutions',
  async (params: BackfillExecutionParams, thunkAPI) => {
    try {
      const { limit, ...rest } = params;
      const defaultParams = {
        page: 1,
        ...rest,
        size: limit || 10,
      };

      return await getBackFillList(defaultParams);
    } catch (error) {
      return thunkAPI.rejectWithValue('Error fetching backfill executions');
    }
  }
);

export const postBackfillData = createAsyncThunk(
  'backfill/postBackfill',
  async (requestData: PostBackfillRequest, thunkAPI) => {
    try {
      await postBackfill(requestData);
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);
